
















































































































































































import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ICompany } from "@/models/company.entity";
import { IRental, Rental } from "@/models/rental.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CompanySelection from "../contact/CompanySelection.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { AddressWithGeo } from "@/models/address.entity";
import { germanZipRule } from "@/lib/rules/contactRule";
import { IReport } from "@/models/report.entity";
@Component({
  components: { CompanySelection },
  filters: {}
})
export default class RentalForm extends Vue {
  ResourceEnum = ResourceEnum;
  CompanyServiceEnum = CompanyServiceEnum;
  CurrencyEnum = CurrencyEnum;
  getAutocompleteFilter = getAutocompleteFilter;

  company: ICompany | null = null;

  @Prop({ default: true })
  showCompany!: boolean;

  @Prop({ default: new Rental({ partnerId: PartnerModule.partner.id }) })
  value!: IRental;

  @Prop()
  report?: IReport;

  get required() {
    return [requiredRule()];
  }

  get germanZipRule() {
    return [germanZipRule(), requiredRule()];
  }

  get partner() {
    return PartnerModule.partner;
  }

  @Watch("value.isPickup")
  onIsPickup() {
    this.value.pickupDateFormable = this.value.end ?? new Date();

    // If we delivered, we set the pickup address to the delivery address
    if (this.value.deliveryLocation) {
      this.value.pickupLocation = new AddressWithGeo(this.value.deliveryLocation);
    } else {
      this.value.pickupLocation = new AddressWithGeo();
    }
  }

  @Watch("value.isDelivery")
  onIsDelivery() {
    this.value.deliveryDateFormable = this.value.start ?? new Date();
    this.value.deliveryLocation = new AddressWithGeo();

    // Set the delivery address to the last towing destination.
    if (this.report && this.report.towing) {
      const lastTowing = this.report.towing[this.report.towing.length - 1];
      if (lastTowing.deliveryLocation) {
        this.value.deliveryLocation = new AddressWithGeo(lastTowing.deliveryLocation);
      }
    }
  }

  @Watch("company")
  onCompanyChange() {
    this.$log.debug(this.company);

    if (this.company) {
      this.value.seller = this.company.invoiceParty;
    }
  }
}
